import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { Modal, Row, Card, CardBody, Form } from "reactstrap"
import Swal from "sweetalert2"
import {
  getUsersforRole,
  overideAllUserRoles,
} from "helpers/fakebackend_helper"
import * as Yup from "yup"

const OverideModal = ({ isOpen, toggle, roleId, userRoleName }) => {
  const dispatch = useDispatch()
  const [users, setUsers] = useState([]) // State to hold fetched users
  const [selectedUserIds, setSelectedUserIds] = useState([]) // State for selected user IDs
  const [selectAll, setSelectAll] = useState(false) // State for "Select All" checkbox

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      user_role_id: roleId,
      user_ids: "", // For storing the comma-separated user IDs
    },
    validationSchema: Yup.object({}),
    onSubmit: async values => {
      values.user_ids = selectedUserIds.join(",") // Set selected user IDs as comma-separated string

      let loadingSwal
      try {
        loadingSwal = Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
        const data = {
          user_role_id: values.user_role_id,
          user_id: values.user_ids,
        }

        const response = await overideAllUserRoles(data)

        if (response && response.status === true) {
          loadingSwal.close()
          Swal.fire({
            title: "Success",
            icon: "success",
            text: "Your Role has been updated.",
          }).then(result => {
            if (result.isConfirmed) {
              toggle()
            }
          })
        } else {
          loadingSwal.close()
          Swal.fire({
            title: "Failure",
            icon: "error",
            text: "Your Role has not been updated.",
          })
        }
      } catch (error) {
        console.error("Error:", error)
        if (loadingSwal) {
          loadingSwal.close()
        }
        Swal.fire({
          title: "Error",
          icon: "error",
          text:
            error.response?.data?.message ||
            "An error occurred while updating your Role.",
        })
      }
    },
  })

  // Fetch users when roleId changes
  useEffect(() => {
    if (roleId) {
      fetchUser()
    }
  }, [roleId])

  const fetchUser = async () => {
    try {
      const response = await getUsersforRole({ user_role: roleId })
      if (response && response.status === true) {
        setUsers(response.data) // Store users in state
      } else {
        console.error("Failed to fetch users")
      }
    } catch (error) {
      console.error("Error fetching users:", error)
    }
  }

 // Handle individual checkbox toggle
 const handleCheckboxChange = userId => {
  setSelectedUserIds(prevSelected => {
    const updatedSelected = prevSelected.includes(userId)
      ? prevSelected.filter(id => id !== userId) // Remove user if already selected
      : [...prevSelected, userId]; // Add user if not selected

    // Check if all users are selected, then set "Select All" to true
    if (updatedSelected.length === users.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }

    return updatedSelected;
  });
};

// Handle "Select All" checkbox toggle
const handleSelectAll = () => {
  if (selectAll) {
    setSelectedUserIds([]); // Uncheck all
  } else {
    const allUserIds = users.map(user => user.id);
    setSelectedUserIds(allUserIds); // Select all
  }
  setSelectAll(!selectAll); // Toggle "Select All"
};

  return (
    <Modal
      className="modal-dialog-centered"
      size="lg"
      isOpen={isOpen}
      toggle={toggle}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myLargeModalLabel">
          Role Override Permissions
        </h5>
        <button
          onClick={toggle}
          type="button"
          className="close"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Card>
          <CardBody>
            <Form
              autoComplete="off"
              onSubmit={e => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <Row>
                <p>
                Please review the {userRoleName} users and select accordingly for permission override.
                 
                </p>
              </Row>
              <Row>
                <div>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th style={{ width: "50px" }}>
                          {" "}
                          {/* Adjusted width for checkbox column */}
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                            style={{ width: "15px", height: "15px" }} // Smaller checkbox size
                          />
                        </th>
                        <th style={{ width: "auto" }}>User Name</th>{" "}
                        {/* Adjusted width for User Name */}
                        <th style={{ width: "100px" }}>Emp Code</th>{" "}
                        {/* Fixed width for Emp Code */}
                      </tr>
                    </thead>
                    <tbody>
                      {users.length > 0 ? (
                        users.map(user => (
                          <tr key={user.id}>
                            <td>
                              <input
                                type="checkbox"
                                checked={selectedUserIds.includes(user.id)}
                                onChange={() => handleCheckboxChange(user.id)}
                                style={{ width: "15px", height: "15px" }} // Smaller checkbox size
                              />
                            </td>
                            <td>{`${user.first_name} ${user.middle_name} ${user.last_name}`}</td>
                            <td>{user.employee_code}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3">No users found.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Row>
              <Row>
                <p>
                  {" "}
                  <strong>Note</strong> : This will also override the permissions of users with special rights.
                </p>
              </Row>
              <Row>
                <div className="mb-3 mt-4 text-center">
                  <button type="submit" className="btn btn-primary">
                    Override Role
                  </button>
                </div>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </div>
    </Modal>
  )
}

export default OverideModal
